<template>
  <div>
    <div id="overlay"  v-if="loading">
    <div class="spinner"></div>
    <br/>
      <h4>Loading...</h4>
    </div>
        <form>
          <div class="box box-info" >
        <div class="p-toolbar p-component mb-4">
            <Button icon="pi pi-plus" class="p-button p-component p-button-success addNewBtn btn-btm-0" label="NEW" @click.prevent="openBasic"/>
           </div>
         </div>
          <Dialog header="Fiscal year" :visible.sync="displayBasic" @show="showNepaliDialogs"
           :style="{width: '50vw'}" :closable="false" :modal="true">

           <div class="p-fluid p-formgrid p-grid">
             <div class="p-field p-col-12 p-md-6">
              <label for="name" >Name</label>
              <InputText type="text" v-model.trim="name"  id="name"/>
            </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="shortName">Start date</label>
                <date-picker v-model="startDate" valueType="format"  v-if="!englishDateEnabled"/>
                <InputText  v-else  class="nepali-calendar" id="startDate" v-model="startDate"/>
            </div>
             <div class="p-field p-col-12 p-md-6">
               <label for="head">End date</label>
               <date-picker v-model="endDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputText v-else class="nepali-calendar" id="endDate" v-model="endDate"/>
             </div>
               <div class="p-field p-col-12 p-md-6">
                 <label for="head">Transaction date</label>
                 <date-picker v-model="txnDate" valueType="format" v-if="!englishDateEnabled"/>
                 <InputText v-else class="nepali-calendar" id="txnDate" v-model="txnDate"/>
             </div>
            <div class="p-field p-col-12 p-md-6">
               <label for="head">Is master?</label>
                 <Checkbox v-model="isMaster" :binary="true"/>
            </div>

          </div>
        <template #footer>
        <Button class="p-button-raised" @click.prevent="addFiscalYear"
             :label="!editing?'Add':'Update'"/>
          <Button class="p-button-raised p-button-info"
            @click.prevent="addAndNewFiscalYear" v-if="!editing"
             label="Add & New"/>
          <Button  class="p-button-raised p-button-danger"
            @click.prevent="cancel" label="Cancel"/>
        </template>
        </Dialog>
        </form>
      </div>
    <!-- </div> -->
</template>
<script>
import DatePicker from 'vue2-datepicker'
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import Dialog from 'primevue/dialog'
// import Toast from 'primevue/toast'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
export default {
  name: 'fiscalYear',
  data() {
    return {
      name: '',
      startDate: null,
      endDate: null,
      txnDate: null,
      isMaster: false,
      editing: false,
      displayBasic: false,
      id: '',
      loading: false,
      englishDateEnabled: true
    }
  },
  mounted() {
    if (!this.$store.getters.englishDate) {
      this.nepaliDate()
    }
  },
  methods: {
    async addFiscalYear() {
      if (this.name.trim === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Fiscal year name cannot be empty!', life: 10000})
        return
      }
      let response = ''
      let fiscalYear = {
        name: this.name,
        startDate: this.startDate,
        endDate: this.endDate,
        transactionStartDate: this.txnDate,
        currentFiscalYear: this.isMaster,
        id: this.id
      }
      if (!this.editing) {
        this.loading = true
        response = await this.$store.dispatch('createFiscalYear', fiscalYear)
        this.loading = false
      } else {
        this.loading = true
        response = await this.$store.dispatch('updateFiscalYear', fiscalYear)
        this.loading = false
      }
      this.responseMessage(response)
      this.closeBasic()
    },
    async addAndNewFiscalYear() {
      if (this.name.trim === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Fiscal year name cannot be empty!', life: 10000})
        return
      }
      let response = ''
      let fiscalYear = {
        name: this.name,
        startDate: this.startDate,
        endDate: this.endDate,
        transactionStartDate: this.txnDate,
        currentFiscalYear: this.isMaster
      }
      this.loading = true
      response = await this.$store.dispatch('createFiscalYear', fiscalYear)
      this.loading = false
      this.responseMessage(response)
    },
    responseMessage(response) {
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 10000})
        this.reset()
        return
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: response.data.message, life: 10000})
        return
      }
    },
    showNepaliDialogs() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
        this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '' && this.editing === false) {
        this.startDate = this.$store.getters.nepaliNewDate
        this.endDate = this.$store.getters.nepaliNewDate
        this.txnDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.startDate = new Date().toISOString().slice(0, 10)
      this.endDate = new Date().toISOString().slice(0, 10)
      this.txnDate = new Date().toISOString().slice(0, 10)
    },
    cancel() {
      this.reset()
      this.closeBasic()
    },
    reset() {
      this.name = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
      this.isMaster = false
      this.editing = false
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    },
    editFiscalYear(data) {
      this.name = data.name
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.startDate = data.startDate
        this.endDate = data.endDate
        this.txnDate = data.transaction
      } else {
        this.startDate = data.startDateNepali
        this.endDate = data.endDateNepali
        this.txnDate = data.transactionDateNepali
      }
      this.isMaster = data.currentFiscalYear
      this.id = data.id
      this.editing = true
      this.openBasic()
    },
    nepaliDate() {
      var startDate = document.getElementById('startDate')
      var endDate = document.getElementById('endDate')
      var txnDate = document.getElementById('txnDate')
      startDate.nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate
      })
      endDate.nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        ndpYearCount: 10
      })
      txnDate.nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        ndpYearCount: 10
      })
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    Dialog,
    Button,
    InputText
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
.forDate{
    z-index: 1009;
    top: -236%;
    left: 73%;
}
</style>



// WEBPACK FOOTER //
// fiscalYearDialog.vue?02703a39